import { makeStyles } from 'tss-react/mui'

export const useStyle = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  upperContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
  },
  leftContainer: {
    display: 'flex',
  },
  rightContainer: {
    display: 'flex',
  },
  headerText: {
    width: '100%',
    fontFamily: theme.typography.fontFamily,
    fontSize: '14px',
    fontWeight: 400,
    color: theme.palette.labraText.primary,
    lineHeight: '20px',
    fontStyle: 'normal',
    letterSpacing: '0.25px',
  },
  count: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    fontWeight: 700,
    color: theme.palette.textBackground.dark,
    lineHeight: '24px',
    fontStyle: 'normal',
    letterSpacing: '0.5px',
  },
  totalCount: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    fontWeight: 400,
    color: theme.palette.labraText.description,
    lineHeight: '24px',
    fontStyle: 'normal',
    letterSpacing: '0.5px',
  },
  middleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2.5),
  },
  completedImage: {
    width: theme.spacing(37),
    height: theme.spacing(31.75),
    borderRadius: theme.spacing(2.5),
  },
  milestonesAchievedText: {
    marginTop: theme.spacing(2),
    fontFamily: theme.typography.fontFamily,
    fontSize: '14px',
    fontWeight: 400,
    color: theme.palette.labraText.description,
    lineHeight: '20px',
    fontStyle: 'normal',
    letterSpacing: '0.25px',
  },
  lowerContainer: {
    marginTop: theme.spacing(1.5),
  },
  horizontalDivider: {
    borderTop: `1px solid ${theme.palette.dividerV2.main}`,
  },
  accordionComponent: {
    display: 'flex',
  },
  linkText: {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
    color: theme.palette.select.light,
    textDecoration: 'none',
    letterSpacing: '0.25px',
  },
}))
